import { action, observable, runInAction } from 'mobx'
// Request
import { FeedbackProcedureRequest } from '../requests/FeedbackProcedureRequest'

class FeedbackProcedureStore {
  @observable page = 0
  @observable size = 10
  @observable totalCount = 0
  @observable queryParamsSignDocument = {
    page: 0,
    size: 10,
    status: null,
    boardType: null,
    title: null,
    startDate: null,
    endDate: null,
  }

  @action clearQueryParamsIncoming = () => {
    this.queryParamsSignDocument = {
      page: 0,
      size: 10,
      title: null,
      status: null,
      boardType: null,
      from_date: null,
      to_date: null,
    }
  }

  @observable feedbackData = []
  @observable fileNameData = []
  @observable commentData = []
  @observable feedbackDetailData = {}
  @observable feedbackDetailDataV2 = {}

  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  @action clearSelectedElectronicDocument = () => {
    this.selectedElectronicDocument = {}
  }

  @action clearFilter = () => {
    this.pageIndex = 0
    this.pageSize = 10
    this.totalCount = 0
  }

  @action setQueryParamsSignDocument = payload => {
    this.queryParamsSignDocument = payload
  }

  @action getFeedbackProcedureList = () => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.getFeedbackProcedureList(
        this.queryParamsSignDocument
      )
        .then(response => {
          this.totalCount = response.data.totalElements
          this.feedbackData = response.data.content
          this.commentData = response.data.content.map(item => item.comments)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createElectronicDocument = dataSubmit => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.createFeedbackProcedure(dataSubmit)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action
  async getElectronicDocumentById(code) {
    try {
      const response = await FeedbackProcedureRequest.getFeedbackProcedureById(
        code
      )
      if (response?.data) {
        // Update the store with the latest data
        this.feedbackDetailData = response.data
        // Force a re-render of components using this data
        runInAction(() => {
          this.feedbackDetailData = { ...response.data }
        })
      }
    } catch (error) {
      console.error('Error fetching feedback detail:', error)
    }
  }

  @action getElectronicDocumentFileName = fileid => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.getFeedbackProcedureFileName(fileid)
        .then(response => {
          this.fileNameData = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getElectronicDocumentByCode = code => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.getFeedbackProcedureByCode(code)
        .then(response => {
          this.feedbackDetailDataV2 = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateElectronicDocumentStatusAndFiles = (id, data) => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.updateFeedbackProcedureStatusAndFiles(id, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action deleteFeedbackProcedure = code => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.deleteFeedbackProcedure(code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateFeedbackProcedure = (data, code) => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.updateFeedbackProcedure(data, code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateElectronicDocumentStatus = (data, code) => {
    return new Promise((resolve, reject) => {
      FeedbackProcedureRequest.updateFeedbackProcedureStatus(data, code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  // Comment electronic document

  @observable commentElectronicDocumentList = []
  @observable electronicDocumentCommentListSortByDatePost = 'ASC'

  @action clearCommentElectronicDocumentList = () => {
    this.commentElectronicDocumentList.length = 0
    this.electronicDocumentCommentListSortByDatePost = 'ASC'
  }
}

export default new FeedbackProcedureStore()
